<ms-betbuilder-pick
    class="option-pick"
    [event]="event"
    [fixtureId]="betBuilderFixtureId"
    [betBuilderMarket]="betBuilderMarket"
    [trackingSource]="tracking.source"
    [sourceOfPick]="sourceOfPick">
    <div class="name bet-builder">
        {{ optionName }}
        @if (option.marketAttribute && showMarketAttribute) {
            <span class="option-attribute">{{ option.marketAttribute }}</span>
        }
    </div>
    @if (showPromoBadge) {
        <span class="promotion-simple-badge badge badge-info">
            <vn-icon size="10" name="theme-badge" />
        </span>
    }
</ms-betbuilder-pick>
